import React, { useMemo } from 'react';
import i18n from '../../i18n';
import { I18nextProvider } from 'react-i18next';
export var TranslationsProvider = function (_a) {
    var children = _a.children, locale = _a.locale;
    var i18nInstance = useMemo(function () { return i18n({ locale: locale }); }, [locale]);
    return (React.createElement(I18nextProvider, { i18n: i18nInstance },
        React.createElement(React.Fragment, null, children)));
};
//# sourceMappingURL=TranslationsProvider.js.map